"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReturnDeclarationRequestPayloadToJSON = exports.ReturnDeclarationRequestPayloadFromJSONTyped = exports.ReturnDeclarationRequestPayloadFromJSON = void 0;
var _1 = require("./");
function ReturnDeclarationRequestPayloadFromJSON(json) {
    return ReturnDeclarationRequestPayloadFromJSONTyped(json, false);
}
exports.ReturnDeclarationRequestPayloadFromJSON = ReturnDeclarationRequestPayloadFromJSON;
function ReturnDeclarationRequestPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'customerNo': json['customerNo'],
        'trackingData': (json['trackingData'].map(_1.ReturnDeclarationRequestPayloadTrackingDataFromJSON)),
    };
}
exports.ReturnDeclarationRequestPayloadFromJSONTyped = ReturnDeclarationRequestPayloadFromJSONTyped;
function ReturnDeclarationRequestPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'customerNo': value.customerNo,
        'trackingData': (value.trackingData.map(_1.ReturnDeclarationRequestPayloadTrackingDataToJSON)),
    };
}
exports.ReturnDeclarationRequestPayloadToJSON = ReturnDeclarationRequestPayloadToJSON;
//# sourceMappingURL=ReturnDeclarationRequestPayload.js.map